import { render, staticRenderFns } from "./ModalResourceFull.vue?vue&type=template&id=d509aa74&scoped=true&"
import script from "./ModalResourceFull.vue?vue&type=script&lang=js&"
export * from "./ModalResourceFull.vue?vue&type=script&lang=js&"
import style0 from "./ModalResourceFull.vue?vue&type=style&index=0&id=d509aa74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d509aa74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VDialog,VSpacer})
